







































































































































import config from "@/config";
import mixins from "vue-typed-mixins";
import { GeneralMixin } from "@/mixins/general-mixin";
import ParticipantNoContentInfoCard from "@/components/participant/participant-no-content-info-card.vue";

export default mixins(GeneralMixin).extend({
  name: "TemperatureHumidityCard",
  components: { ParticipantNoContentInfoCard },
  props: ["cardTitle", "roomData"],
  data() {
    return {
      roomInfo: config.roomInfo,
    };
  },
  computed: {
    hasHumidityTemperatureData(): boolean {
      return this.dashboardData?.real_time_ht?.length;
    },
  },
  methods: {
    getDeviceOrRoomName(name: string): string {
      if (!name) return this.$t("devices.unknown") as string;
      const n = name
        ?.toLowerCase()
        ?.replaceAll(" ", "_")
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return this.$t(`devices.${n}`) as string;
    },
    getDeviceStatus(state: number): string {
      const s = this.stateInfo(state);
      if (!s) return this.$t("devices.status.unknown") as string;
      return this.$t(`devices.status.${s.toLowerCase()}`) as string;
    },
  },
});
